/// <reference path="./SimpleListItem.ts" />
namespace HA.Core.HTML.TBox {
    export class ListItem extends SimpleListItem {

        protected initialize(data: any) {
            data = "* " + data;
            super.initialize(data);
        }

    }
}
